export const piHeaders = [
  {
    text: "Service",
    sortable: true,
    value: "service",
    name: "service",
  },
  {
    text: "Buy",
    sortable: false,
    value: "adultBuy1",
    name: "adultBuy",
  },
  {
    text: "Sell",
    sortable: false,
    value: "adultSell1",
    name: "adultSell",
  },
  {
    text: "Marketplace",
    sortable: false,
    value: "marketPlace",
    name: "marketPlace",
  },
  {
    text: "API",
    sortable: false,
    value: "api",
    name: "api",
  },
];
export const ppHeaders = [
  {
    text: "Service",
    sortable: true,
    value: "service",
    name: "service",
  },
  {
    text: "Adult Buy",
    sortable: false,
    value: "adultBuy1",
    name: "adultBuy",
  },
  {
    text: "Adult Sell",
    sortable: false,
    value: "adultSell1",
    name: "adultSell",
  },
  {
    text: "Child Buy",
    sortable: false,
    value: "childBuy1",
    name: "childBuy",
  },
  {
    text: "Child Sell",
    sortable: false,
    value: "childSell1",
    name: "childSell",
  },
  {
    text: "Infant Buy",
    sortable: false,
    value: "infantBuy1",
    name: "infantBuy",
  },
  {
    text: "Infant Sell",
    sortable: false,
    value: "infantSell1",
    name: "infantSell",
  },
  {
    text: "Marketplace",
    sortable: false,
    value: "marketPlace",
    name: "marketPlace",
  },
  {
    text: "API",
    sortable: false,
    value: "api",
    name: "api",
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/suppliers/supplier-rates/add/add-rates-season-headers.js